import React from 'react';
const EyeSVG = ({ color = 'white', className, onClick, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      className={className}
      onClick={onClick}
    >
      <path
        d="M17.817 8.3349C17.6446 8.11691 13.5507 3 8.97394 3C4.39668 3 0.302426 8.11704 0.130398 8.3349L0 8.5L0.130398 8.6651C0.302794 8.88309 4.39668 14 8.97394 14C13.5508 14 17.6449 8.88296 17.817 8.6651L17.9474 8.5L17.817 8.3349ZM8.97394 13.4687C5.09866 13.4687 1.42726 9.38021 0.681295 8.5C1.42705 7.61958 5.09856 3.53133 8.97394 3.53133C12.8489 3.53133 16.5206 7.61979 17.2661 8.5C16.5207 9.38078 12.8516 13.4687 8.97394 13.4687Z"
        fill={color}
      />
      <path
        d="M8.97378 5.31567C7.2185 5.31567 5.78967 6.70065 5.78967 8.40329C5.78967 10.1059 7.21814 11.4911 8.97378 11.4911C10.7295 11.4911 12.1581 10.1059 12.1581 8.40329C12.1581 6.7008 10.7293 5.31567 8.97378 5.31567ZM8.97378 10.9664C7.5165 10.9664 6.33097 9.81641 6.33097 8.40309C6.33097 6.98997 7.5165 5.84036 8.97378 5.84036C10.4317 5.84036 11.6172 6.98997 11.6172 8.40309C11.617 9.81661 10.4315 10.9664 8.97378 10.9664Z"
        fill={color}
      />
    </svg>
  );
};

export default EyeSVG;
